import React from "react";
import { useDispatch } from "react-redux";
import InputSearch from "../../../common/views/InputSearch";
import { setTerm } from "../../reducers/posSlice";

const PosSearch = () => {
    const dispatch = useDispatch();

    return (
      <InputSearch 
        placeholder="Cerca punto vendita ..."
        onChange={ (value) => {
          dispatch(setTerm(value))
        } }
      />      
    );
};

export default PosSearch;